export default {"src":"/_next/static/media/rainbow-blue-to-purple-right.74c63318.svg","height":220,"width":1920,"blurWidth":0,"blurHeight":0};